import './Conents.styles.css';
import dayjs from 'dayjs';
import { ArticleSearchCard } from '../../../../components/articlcle-search-card/ArticleSearchCard.tsx';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { REGULATION_TYPE } from '../../../../constants/regulation-type.tsx';
import type { RegulationCardType } from '../../Dashboard.types.ts';
import { getIcon } from '../../Dashboard.helpers.tsx';
import { useService } from '../../Dashboard.hooks.ts';

export default function ContentTopic() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const topic = searchParams.get('topicId');
  const { searchedRegulations } = useService({ topic, type: [], unit: [], search: null });

  const topics = Object.entries(REGULATION_TYPE).map(([key, label]) => {
    return {
      key,
      label,
      items:
        searchedRegulations?.filter(
          (regulation: { type: string | number }) => regulation.type === Number(key),
        ) || [],
    };
  });

  return (
    <div>
      <h1>{t('common.search-results')}</h1>
      {topics?.map((item: { key: string; label: string; items: RegulationCardType[] }) => (
        <div className="search-topic-container">
          <h2>
            {getIcon({ type: Number(item.key) })} {item.label} ({item.items.length})
          </h2>
          {item.items.length ? (
            item.items.map((regulation: RegulationCardType) => (
              <ArticleSearchCard
                id={regulation.id}
                title={regulation.title}
                type={regulation.type}
                confirmed={Boolean(regulation.confirmationDate)}
                created={dayjs(regulation.creationDate).format('DD.MM.YYYY') || 'Not set'}
                status={dayjs(regulation.confirmationDate).format('DD.MM.YYYY') || 'Not set'}
                shortDescription={regulation.shortDescription}
                key={regulation.id}
              />
            ))
          ) : (
            <div>{t('common.no-entities')}</div>
          )}
        </div>
      ))}
    </div>
  );
}
